/* RESPONSIBLE TEAM: team-inbox */
import toBackendPermissionKey from 'embercom/lib/settings/permissions/to-backend-permission-key';

export default function extractPermissionKeySections(key) {
  let [actionKey, ...permission] = toBackendPermissionKey(key).split('__').reverse();
  let actionParent = permission.reverse().join('__');

  return [actionParent, actionKey];
}
